import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({ isLoggedIn }) => {
  // FIX: also check localStorage directly as a fallback
  // isLoggedIn prop from App.js may be stale if App re-renders before localStorage is read
  const localCheck = localStorage.getItem('isLoggedIn') === 'true';
  return (isLoggedIn || localCheck) ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
